import { useState } from 'react';
import { communityPosts } from '@/mocks/homeData';

export default function CommunityPosts() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="community" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_300px] lg:items-start">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">COMMUNITY</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              吃瓜社区热帖
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              网友自己整理、补充和讨论的地方，热度越高越靠前。想聊两句，往下走就是评论区。
            </p>

            <ul className="mt-6 space-y-3">
              {communityPosts.map((post) => (
                <li key={post.id}>
                  <article className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-heading text-base font-bold text-secondary-800">
                      {post.avatar}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm font-medium text-foreground-900">{post.author}</span>
                        <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">
                          {post.badge}
                        </span>
                      </div>
                      <h3 className="mt-1.5 font-heading text-base font-semibold text-foreground-950">
                        {post.title}
                      </h3>
                      <p className="mt-1 text-sm text-foreground-600">{post.excerpt}</p>
                      <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-chat-3-line" aria-hidden="true" />
                          {post.replies} 条回复
                        </span>
                        <button
                          type="button"
                          onClick={() => toggleLike(post.id)}
                          className={`flex items-center gap-1 transition-colors ${
                            liked[post.id] ? 'text-primary-600' : 'hover:text-primary-600'
                          }`}
                        >
                          <i
                            className={liked[post.id] ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'}
                            aria-hidden="true"
                          />
                          {post.likes + (liked[post.id] ? 1 : 0)}
                        </button>
                      </div>
                    </div>
                  </article>
                </li>
              ))}
            </ul>
          </div>

          <aside className="rounded-lg border border-background-200 bg-secondary-50 p-5 lg:sticky lg:top-32">
            <h3 className="font-heading text-base font-bold text-foreground-950">社区小贴士</h3>
            <ul className="mt-4 space-y-3.5">
              {[
                { icon: 'ri-shield-check-line', text: '搬运内容请标注来源，方便别人核对。' },
                { icon: 'ri-emotion-happy-line', text: '对事不对人，理性吃瓜不上头。' },
                { icon: 'ri-lightbulb-line', text: '补充新动态时附上时间与出处更好。' },
                { icon: 'ri-forbid-2-line', text: '涉及未证实的说法，请先标注待核实。' },
              ].map((tip) => (
                <li key={tip.text} className="flex items-start gap-2.5">
                  <i className={`${tip.icon} mt-0.5 text-primary-500`} aria-hidden="true" />
                  <span className="text-xs leading-relaxed text-foreground-700">{tip.text}</span>
                </li>
              ))}
            </ul>
            <a
              href="#comments"
              className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-chat-smile-2-line" aria-hidden="true" />
              去评论区聊聊
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}